import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SettingsOverviewDataProvider } from '@web-services/settings/settings-overview/settings-overview.data.service';
@Component({
	selector: 'settings-navigation',
	template: require('./settings-navigation.component.html'),
	styles: [require('./settings-navigation.component.scss')],
	encapsulation: ViewEncapsulation.None
})
export class SettingsNavigationComponent implements OnInit {
	showCompanySettings = false;
	showGlobalSettings = false;
	settingsLists;

	constructor(
		@Inject(DOCUMENT) private document: Document,
		private settingsOverviewService: SettingsOverviewDataProvider
	) {}

	checkActiveSettingsNavItem(url: string) {
		if (
			url === '/settings/companies' &&
			(this.document.location.pathname === '/settings/company/edit' ||
				this.document.location.pathname.includes('/settings/company/'))
		) {
			return true;
		}

		return this.document.location.pathname === url;
	}

	getSettingsOverviewList() {
		this.settingsOverviewService
			.settingsOverview()
			.filter(data => data !== null)
			.subscribe(data => (this.settingsLists = data));
	}

	ngOnInit(): void {
		this.getSettingsOverviewList();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/settings/settings-overview/settings-navigation/settings-navigation.component.ts